"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _List = _interopRequireDefault(require("../components/List"));
// Arturo will redesign...
var WeeklyLineups = function WeeklyLineups(_ref) {
  var week = _ref.week,
    activeWeek = _ref.activeWeek;
  return /*#__PURE__*/_react["default"].createElement(_List["default"], {
    week: week,
    activeWeek: activeWeek
  });
};
var _default = exports["default"] = WeeklyLineups;